import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as DB_INTERFACE from '../interfaces/DB.interface';
import * as PDT_INTERFACE from '../interfaces/PDT.interface';

export function DBToForm(
    oldPDT: PDT_INTERFACE.accessPermissionInterface,
    contactTypeID: FORM_INTERFACE.contactTypeIdInterface,
) {
    let fromDateAndTime: Date = new Date(oldPDT.startDate);
    let toDateAndTime: Date = new Date(oldPDT.endDate);
    const generalInformation: FORM_INTERFACE.generalInformationInterface = {
        //! FIX
        // @ts-ignore
        accessReason: oldPDT.accessType.id,
        headquarters: oldPDT.dataCenter.id,
        accessMotives: setMotives(oldPDT.accessPermissionMotives),
        otherMotive: setOtherMotive(oldPDT.accessPermissionMotives),
        emergencyChangeReason: oldPDT.emergencyComment,
        requiresInterruption: oldPDT.serviceInterruption,
        orderNumber: oldPDT.serviceOrder,
        fromDateVal: getFormattedDate(fromDateAndTime),
        fromTimeVal: getFormattedTime(fromDateAndTime),
        toDateVal: getFormattedDate(toDateAndTime),
        toTimeVal: getFormattedTime(toDateAndTime),
        additionalComment: '',
    };
    const involvedPeople: FORM_INTERFACE.involvedPeopleInterface = setInvolvedPeople(
        oldPDT.accessContacts,
    );
    const accessCars: FORM_INTERFACE.accessCarsInterface[] = setAccessCars(oldPDT.vehicles);
    const tasks: FORM_INTERFACE.tasksInterface[] = setTasks(oldPDT.tasks);
    const hardwareTransfer: FORM_INTERFACE.hardwareTransferInterface[] = setHardwareTransfer(
        oldPDT.accessPermissionEquipments,
    );
    const oldAccessTicket: FORM_INTERFACE.accessTicketInterface = {
        generalInformation,
        involvedPeople,
        accessCars,
        tasks,
        hardwareTransfer,
        contactTypeID,
    };
    return oldAccessTicket;
}

function setHardwareTransfer(
    oldHardwareInformation: PDT_INTERFACE.accessPermissionEquipmentsInterface[],
) {
    // this most assuredly broke
    //
    // let hardware: FORM_INTERFACE.hardwareInterface[] = Array();
    // let transferInformation: FORM_INTERFACE.transferInformationInterface = {} as FORM_INTERFACE.transferInformationInterface;
    // if (oldHardwareInformation.length > 0) {
    //     transferInformation = {
    //         movementType: {
    //             id: oldHardwareInformation[0].movementType,
    //         },
    //         reasonForTransfer: oldHardwareInformation[0].accessEquipmentDepartureType.id,
    //         lengthOfTransfer: oldHardwareInformation[0].accessEquipmentDeparturePeriodType.id,
    //         destination: oldHardwareInformation[0].destination,
    //         motive: oldHardwareInformation[0].departureMotive,
    //     };
    //     oldHardwareInformation.forEach(oldEquipment => {
    //         hardware.push({
    //             name: oldEquipment.accessEquipment.name,
    //             model: oldEquipment.accessEquipment.model,
    //             brand: oldEquipment.accessEquipment.brand,
    //             measureUnit: oldEquipment.accessEquipment.measureUnit,
    //             nominalVoltage: oldEquipment.accessEquipment.voltage.replace('.', ','),
    //             serialNumber: oldEquipment.accessEquipment.serial,
    //             nominalConsumption: oldEquipment.accessEquipment.consumption.replace('.', ','),
    //         });
    //     });
    // }
    // return { transferInformation, hardware };
    return Array();
}

function setTasks(oldTasks: PDT_INTERFACE.tasksInterface[]) {
    let tasks: FORM_INTERFACE.tasksInterface[] = Array();
    oldTasks.forEach(oldTask => {
        tasks.push({
            person: oldTask.taskType.id,
            description: oldTask.name,
        });
    });
    return tasks;
}

function setAccessCars(oldCars: PDT_INTERFACE.vehiclesInterface[]) {
    let cars: FORM_INTERFACE.accessCarsInterface[] = Array();
    oldCars.forEach(oldCar => {
        cars.push({
            brand: oldCar.brand,
            model: oldCar.model,
            numberPlate: oldCar.licensePlate,
        });
    });
    return cars;
}

function setInvolvedPeople(oldContacts: PDT_INTERFACE.accessContactsInterface[]) {
    let authorizedPeople: FORM_INTERFACE.authorizedPeopleInterface[] = Array();
    let additionalPeople: FORM_INTERFACE.additionalPeopleInterface[] = Array();
    let applicant: FORM_INTERFACE.applicantInterface[] = Array();
    oldContacts.forEach(oldContact => {
        oldContact.contactDetails.forEach(detail => {
            switch (detail.contactType.id) {
                case 1:
                    break;

                case 2:
                    authorizedPeople.push({
                        contactId: oldContact.contactId,
                        firstName: oldContact.name,
                        lastName: oldContact.lastName,
                        telephoneNumber: oldContact.phone,
                        idNumber: oldContact.identification,
                    });
                    break;

                case 3:
                    applicant.push({
                        contactId: oldContact.contactId,
                        firstName: oldContact.name,
                        lastName: oldContact.lastName,
                        idNumber: oldContact.identification,
                        telephoneNumber: oldContact.phone,
                        company: oldContact.company,
                    });
                    break;

                case 4:
                    additionalPeople.push({
                        firstName: oldContact.name,
                        lastName: oldContact.lastName,
                        idNumber: oldContact.identification,
                        company: oldContact.company,
                    });
                    break;

                default:
                    break;
            }
        });
    });
    return { applicant, authorizedPeople, additionalPeople };
}

function setOtherMotive(oldMotives: PDT_INTERFACE.accessPermissionMotivesInterface[]) {
    let otherMotive: string = '';
    oldMotives.forEach(oldMotive => {
        //! FIX
        // @ts-ignore
        if (oldMotive.accessMotive.id == 20) {
            otherMotive = oldMotive.accessMotiveDescription;
        }
    });
    return otherMotive;
}

function setMotives(oldMotives: PDT_INTERFACE.accessPermissionMotivesInterface[]) {
    let motives: number[] = Array();
    oldMotives.forEach(oldMotive => {
        //! FIX
        // @ts-ignore
        motives.push(oldMotive.accessMotive.id);
    });
    return motives;
}

function getFormattedDate(date: Date) {
    return (
        date.getFullYear().toString() +
        '-' +
        (date.getMonth() + 1).toString() +
        '-' +
        date.getDate().toString()
    );
}

function getFormattedTime(date: Date) {
    let time: string = '';
    let hours = date.getHours().toString();
    hours = hours.length == 1 ? '0' + hours : hours;
    time += hours + ':';
    let minutes = date.getMinutes().toString();
    minutes = minutes.length == 1 ? '0' + minutes : minutes;
    time += minutes + ':00';
    return time;
}

export function CommentsToForm(
    workflowAccessPermissionsStates: PDT_INTERFACE.workflowAccessPermissionsStatesInterface[],
) {
    let workflowComments: FORM_INTERFACE.workflowCommentsInterface[] = Array();
    workflowAccessPermissionsStates.forEach(comment => {
        if (comment.comment !== null && comment.commentarySection !== null) {
            workflowComments.push({
                comment: comment.comment,
                stepID: comment.commentarySection.id,
                stepName: comment.commentarySection.name,
            });
        }
    });
    return workflowComments;
}

export function AccessFormValuesToForm(dataCreateTicket: DB_INTERFACE.dataCreateTicketInterface) {
    const formValues: FORM_INTERFACE.accessFormValuesInterface = {
        generalInformation: {
            dataCenters: Array(),
            reasons: Array(),
            motives: Array(),
        },
        tasks: {
            taskTypes: Array(),
        },
        hardwareTransfer: {
            accessEquipmentDepartureTypes: Array(),
            accessEquipmentDeparturePeriodTypes: Array(),
            movementTypes: Array(),
        },
        contactTypes: Array(),
    };
    dataCreateTicket.dataCenters.forEach(dataCenter => {
        let data = {
            value: dataCenter.id,
            text: dataCenter.name,
        };
        formValues.generalInformation.dataCenters.push(data);
    });
    dataCreateTicket.accessTypes.forEach(accessType => {
        let motives = Array();
        accessType.accessTypesMotives.forEach(motive => {
            let data = {
                value: motive.accessMotive.id,
                text: motive.accessMotive.name,
                reasonMotiveId: motive.id,
            };
            motives.push(data);
        });
        let data = {
            value: accessType.id,
            text: accessType.name,
            motives,
        };
        formValues.generalInformation.reasons.push(data);
    });
    dataCreateTicket.contactTypes.forEach(contactType => {
        let data = {
            value: contactType.id,
            text: contactType.name,
        };
        formValues.contactTypes.push(data);
    });
    dataCreateTicket.taskTypes.forEach(taskType => {
        let data = {
            value: taskType.id,
            text: taskType.name,
            description: taskType.description,
        };
        formValues.tasks.taskTypes.push(data);
    });
    dataCreateTicket.accessEquipmentDepartureTypes.forEach(departure => {
        let data = {
            id: departure.id,
            name: departure.name,
        };
        formValues.hardwareTransfer.accessEquipmentDepartureTypes.push(data);
    });
    dataCreateTicket.accessEquipmentDeparturePeriodTypes.forEach(period => {
        let data = {
            value: period.id,
            text: period.name,
        };
        formValues.hardwareTransfer.accessEquipmentDeparturePeriodTypes.push(data);
    });
    dataCreateTicket.movementTypes.forEach(type => {
        let data = {
            value: type.id,
            text: type.name,
        };
        formValues.hardwareTransfer.movementTypes.push(data);
    });
    return formValues;
}
